<template lang="pug">
k-page.post( :key='postData.id' )
  d-main-image( v-bind=`{ img, show }` @load='pageLoaded' )
  k-hero
  w-go-down
  k-main( :title='title' )
    .content( v-html='content' )
  comments
  .bottom-spacer
</template>

<script lang="js">
import routeEvents from '@/lib/route-events'
import KPage from '@/blocks/k-page'
import KHero from '@/blocks/k-hero'
import KMain from '@/blocks/k-main'
import DMainImage from '@/displays/d-main-image'
import WGoDown from '@/widgets/w-go-down'
import Comments from '@/components/comments'
import { Post } from '@/mixins'

export default {
  name: 'PostPage',
  mixins: [ Post ],
  components: { Comments, KPage, KHero, KMain, DMainImage, WGoDown },
  props: {
    id: {
      type: Number,
      default: 0
    },
    path: {
      type: String,
      default: ''
    },
    post: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      promos: [],
      content: '',
      classes: { small: false }
    }
  },
  beforeRouteUpdate: routeEvents.toPath,
  created() {},
  mounted() {
    this.promos = this.post.promo_reel || []
  },
  methods: {
  },
  computed: {}
}
</script>

<style lang="scss">
.post {

}
</style>
